const ArrowButton = ({ onClick, role }) => (
    <div className={`arrow ${role}`}>
        <button onClick={onClick} />
    </div>
)

export default ArrowButton
